//export const API_DOMAIN = "https://uat.apps.tip-group.com";
export const API_DOMAIN = "https://tiptrainingapim-v1.tip-group.com";
export const API_DOMAIN_R = "https://training-v1.tip-group.com";
//export const API_DOMAIN = "https://test.tip-group.com/SSO"; // New doain changes


export const APP_CODE = "WKSHP";
export const APP_CODE_TIME = "TimeTrack";
export const Workshop = API_DOMAIN_R + "/Workshop/#ResourcePlanner";
export const WorkshopLogin = API_DOMAIN_R + "/Workshop/";
export const WorkshopTechnician = API_DOMAIN_R + "/Workshop/#/TechnicianList";
// AUTH CONSTANTS
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const GET_USER_REQUEST = "GET_USER_REQUEST";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAILURE = "GET_USER_FAILURE";

export const GET_APP_NAVIGATION_REQUEST = "GET_APP_NAVIGATION_REQUEST";
export const GET_APP_NAVIGATION_SUCCESS = "GET_APP_NAVIGATION_SUCCESS";
export const GET_APP_NAVIGATION_FAILURE = "GET_APP_NAVIGATION_FAILURE";

// USER MESSAGE CONSTANTS
export const ADD_MESSAGE_SAVE = "ADD_MESSAGE_SAVE";
export const ADD_MESSAGE_ERROR = "ADD_MESSAGE_ERROR";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

// PROFILE MESSAGE CONSTANTS
export const SAVE_PROFILE_REQUEST = "SAVE_PROFILE_REQUEST";
export const SAVE_PROFILE_SUCCESS = "SAVE_PROFILE_SUCCESS";
export const SAVE_PROFILE_FAILURE = "SAVE_PROFILE_FAILURE";

//TECHNICIAN TIMESHEETFETCH

export const FETCH_TIMESHEET_REQUEST = "FETCH_TIMESHEET_REQUEST";
export const FETCH_TIMESHEET_SUCCESS = "FETCH_TIMESHEET_SUCCESS";
export const FETCH_TIMESHEET_FAILURE = "FETCH_TIMESHEET_FAILURE";

//MONTH DATA FECTH

export const FETCH_MONTHDATA_REQUEST = "FETCH_MONTHDATA_REQUEST";
export const FETCH_MONTHDATA_SUCCESS = "FETCH_MONTHDATA_SUCCESS";
export const FETCH_MONTHDATA_FAILURE = "FETCH_MONTHDATA_FAILURE";

//UPDATE TECHNICIAN TIMESHEET

export const SAVE_TIMESHEET_REQUEST = "SAVE_TIMESHEET_REQUEST";
export const SAVE_TIMESHEET_SUCCESS = "SAVE_TIMESHEET_SUCCESS";
export const SAVE_TIMESHEET_FAILURE = "SAVE_TIMESHEET_FAILURE";

//USER DATA FOR TECHICIAN
export const SAVE_TECHNICIAN_DATA = "SAVE_TECHNICIAN_DATA";
export const DELETE_TECHNICIAN_DATA = "DELETE_TECHNICIAN_DATA";
//SHOW HIDE MODEL POPUP
export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";

//TECHNICIAN CALL OUT
export const SAVE_TECHNICIANCALLOUTSAVE_REQUEST = "SAVE_TIMESHEET_REQUEST";
export const SAVE_TECHNICIANCALLOUTSAVE_SUCCESS = "SAVE_TIMESHEET_SUCCESS";
export const SAVE_TECHNICIANCALLOUTSAVE_FAILURE = "SAVE_TIMESHEET_FAILURE";

//TECHNICIAN WORK HOURS

export const SAVE_TECHNICIANWORKHOURS_REQUEST =
  "SAVE_TECHNICIANWORKHOURS_REQUEST";
export const SAVE_TECHNICIANWORKHOURS_SUCCESS =
  "SAVE_TECHNICIANWORKHOURS_SUCCESS";
export const SAVE_TECHNICIANWORKHOURS_FAILURE =
  "SAVE_TECHNICIANWORKHOURS_FAILURE";

//GET TIMESHEET SECURITY

export const GET_TIMESHEETSECURITY_REQUEST = "GET_TIMESHEETSECURITY_REQUEST";
export const GET_TIMESHEETSECURITY_SUCCESS = "GET_TIMESHEETSECURITY_SUCCESS";
export const GET_TIMESHEETSECURITY_FAILURE = "GET_TIMESHEETSECURITY_FAILURE";

//MANAGER  WEEK DATA
export const FETCH_MANAGER_MONTHDATA_REQUEST =
  "FETCH_MANAGER_MONTHDATA_REQUEST";
export const FETCH_MANAGER_MONTHDATA_SUCCESS =
  "FETCH_MANAGER_MONTHDATA_SUCCESS";
export const FETCH_MANAGER_MONTHDATA_FAILURE =
  "FETCH_MANAGER_MONTHDATA_FAILURE";

// UPDATE MANAGER WEEKdATA
export const SAVE_MANAGER_MONTHDATA_REQUEST = "SAVE_MANAGER_MONTHDATA_REQUEST";
export const SAVE_MANAGER_MONTHDATA_SUCCESS = "SAVE_MANAGER_MONTHDATA_SUCCESS";
export const SAVE_MANAGER_MONTHDATA_FAILURE = "SAVE_MANAGER_MONTHDATA_FAILURE";

// MANAGER SHIFT UPDATE

export const UPDATE_MANAGER_SHIFT_REQUEST = "UPDATE_MANAGER_SHIFT_REQUEST";
export const UPDATE_MANAGER_SHIFT_SUCCESS = "UPDATE_MANAGER_SHIFT_SUCCESS";
export const UPDATE_MANAGER_SHIFT_FAILURE = "UPDATE_MANAGER_SHIFT_FAILURE";

export const ADD_MANAGER_SHIFT_REQUEST = "ADD_MANAGER_SHIFT_REQUEST";
export const ADD_MANAGER_SHIFT_SUCCESS = "ADD_MANAGER_SHIFT_SUCCESS";
export const ADD_MANAGER_SHIFT_FAILURE = "ADD_MANAGER_SHIFT_FAILURE";

export const DELETE_MANAGER_SHIFT_REQUEST = "DELETE_MANAGER_SHIFT_REQUEST";
export const DELETE_MANAGER_SHIFT_SUCCESS = "DELETE_MANAGER_SHIFT_SUCCESS";
export const DELETE_MANAGER_SHIFT_FAILURE = "DELETE_MANAGER_SHIFT_FAILURE";

// MANAGER HOLIDAY

export const UPDATE_MANAGER_HOLIDAY_REQUEST = "UPDATE_MANAGER_HOLIDAY_REQUEST";
export const UPDATE_MANAGER_HOLIDAY_SUCCESS = "UPDATE_MANAGER_HOLIDAY_SUCCESS";
export const UPDATE_MANAGER_HOLIDAY_FAILURE = "UPDATE_MANAGER_HOLIDAY_FAILURE";

export const ADD_MANAGER_HOLIDAY_REQUEST = "ADD_MANAGER_HOLIDAY_REQUEST";
export const ADD_MANAGER_HOLIDAY_SUCCESS = "ADD_MANAGER_HOLIDAY_SUCCESS";
export const ADD_MANAGER_HOLIDAY_FAILURE = "ADD_MANAGER_HOLIDAY_FAILURE";

export const DELETE_MANAGER_HOLIDAY_REQUEST = "DELETE_MANAGER_HOLIDAY_REQUEST";
export const DELETE_MANAGER_HOLIDAY_SUCCESS = "DELETE_MANAGER_HOLIDAY_SUCCESS";
export const DELETE_MANAGER_HOLIDAY_FAILURE = "DELETE_MANAGER_HOLIDAY_FAILURE";

//Employee OnBoard

export const UPDATE_MANAGER_EMPLOYEE_REQUEST =
  "UPDATE_MANAGER_EMPLOYEE_REQUEST";
export const UPDATE_MANAGER_EMPLOYEE_SUCCESS =
  "UPDATE_MANAGER_EMPLOYEE_SUCCESS";
export const UPDATE_MANAGER_EMPLOYEE_FAILURE =
  "UPDATE_MANAGER_EMPLOYEE_FAILURE";

export const ADD_MANAGER_EMPLOYEE_REQUEST = "ADD_MANAGER_EMPLOYEE_REQUEST";
export const ADD_MANAGER_EMPLOYEE_SUCCESS = "ADD_MANAGER_EMPLOYEE_SUCCESS";
export const ADD_MANAGER_EMPLOYEE_FAILURE = "ADD_MANAGER_EMPLOYEE_FAILURE";

export const DELETE_MANAGER_EMPLOYEE_REQUEST =
  "DELETE_MANAGER_EMPLOYEE_REQUEST";
export const DELETE_MANAGER_EMPLOYEE_SUCCESS =
  "DELETE_MANAGER_EMPLOYEE_SUCCESS";
export const DELETE_MANAGER_EMPLOYEE_FAILURE =
  "DELETE_MANAGER_EMPLOYEE_FAILURE";

// Update Schedulehours

export const UPDATE_MANAGER_SCHEDULEHOURS_REQUEST =
  "UPDATE_MANAGER_SCHEDULEHOURS_REQUEST";
export const UPDATE_MANAGER_SCHEDULEHOURS_SUCCESS =
  "UPDATE_MANAGER_SCHEDULEHOURS_SUCCESS";
export const UPDATE_MANAGER_SCHEDULEHOURS_FAILURE =
  "UPDATE_MANAGER_SCHEDULEHOURS_FAILURE";

export const UPDATE_MANAGER_WEEKLYSCHEDULE_REQUEST =
  "UPDATE_MANAGER_WEEKLYSCHEDULE_REQUEST";
export const UPDATE_MANAGER_WEEKLYSCHEDULE_SUCCESS =
  "UPDATE_MANAGER_WEEKLYSCHEDULE_SUCCESS";
export const UPDATE_MANAGER_WEEKLYSCHEDULE_FAILURE =
  "UPDATE_MANAGER_WEEKLYSCHEDULE_FAILURE";

//Manager standby
export const UPDATE_MANAGER_STANDBY_REQUEST = "UPDATE_MANAGER_STANDBY_REQUEST";
export const UPDATE_MANAGER_STANDBY_SUCCESS = "UPDATE_MANAGER_STANDBY_SUCCESS";
export const UPDATE_MANAGER_STANDBY_FAILURE = "UPDATE_MANAGER_STANDBY_FAILURE";

// Hours Analytics

export const FETCH_MANAGER_HOURANALYTICS_REQUEST =
  "FETCH_MANAGER_HOURANALYTICS_REQUEST";
export const FETCH_MANAGER_HOURANALYTICS_SUCCESS =
  "FETCH_MANAGER_HOURANALYTICS_SUCCESS";
export const FETCH_MANAGER_HOURANALYTICS_FAILURE =
  "FETCH_MANAGER_HOURANALYTICS_FAILURE";
  
// Recalculate Hour
export const FETCH_RECALCULATE_HOUR_REQUEST =
  "FETCH_RECALCULATE_HOUR_REQUEST";
export const FETCH_RECALCULATE_HOUR_SUCCESS =
  "FETCH_RECALCULATE_HOUR_SUCCESS";
export const FETCH_RECALCULATE_HOUR_FAILURE =
  "FETCH_RECALCULATE_HOUR_FAILURE";

// ADD WEEK PLANNER

export const ADD_WEEK_PLANNER_REQUEST = "ADD_WEEK_PLANNER_REQUEST";
export const ADD_WEEK_PLANNER_SUCCESS = "ADD_WEEK_PLANNER_SUCCESS";
export const ADD_WEEK_PLANNER_FAILURE = "ADD_WEEK_PLANNER_FAILURE";

// UPDATE WEEK PLANNER

export const UPDATE_WEEK_PLANNER_REQUEST = "UPDATE_WEEK_PLANNER_REQUEST";
export const UPDATE_WEEK_PLANNER_SUCCESS = "UPDATE_WEEK_PLANNER_SUCCESS";
export const UPDATE_WEEK_PLANNER_FAILURE = "UPDATE_WEEK_PLANNER_FAILURE";

// GET SHIFT WISE EMPLOYEES DATA

export const GET_SHIFTWISEEMPLOYEES_REQUEST = "GET_SHIFTWISEEMPLOYEES_REQUEST";
export const GET_SHIFTWISEEMPLOYEES_SUCCESS = "GET_SHIFTWISEEMPLOYEES_SUCCESS";
export const GET_SHIFTWISEEMPLOYEES_FAILURE = "GET_SHIFTWISEEMPLOYEES_FAILURE";

//StandByDetails

export const FETCH_STANDBYDETAILS_REQUEST = "FETCH_STANDBYDETAILS_REQUEST";
export const FETCH_STANDBYDETAILS_SUCCESS = "FETCH_STANDBYDETAILS_SUCCESS";
export const FETCH_STANDBYDETAILS_FAILURE = "FETCH_STANDBYDETAILS_FAILURE";
